/**
 * Feature Access Configuration
 * Centralized configuration for feature access control
 */
export const FEATURE_CONFIG = {
  utilities: {
    public: true,
    requiresAuth: false,
    showLoginPrompt: false
  },
  games: {
    public: true,
    requiresAuth: false,
    leaderboard: {
      requiresAuth: true,
      showLoginPrompt: true,
      promptMessage: "Please login to view leaderboard and save your scores"
    }
  },
  chat: {
    public: false,
    requiresAuth: true
  },
  blog: {
    public: false,
    requiresAuth: true,
    publicViewing: true
  },
  movieBooking: {
    public: false,
    requiresAuth: true,
    showLoginPrompt: true,
    promptMessage: "Please login to access Movie Booking"
  },
  dashboard: {
    public: false,
    requiresAuth: true
  }
};

/**
 * Check if a feature is public (accessible without authentication)
 */
export const isFeaturePublic = (featureName) => {
  return FEATURE_CONFIG[featureName]?.public || false;
};

/**
 * Check if a feature or sub-feature requires authentication
 */
export const requiresAuth = (featureName, subFeature = null) => {
  const config = FEATURE_CONFIG[featureName];
  if (!config) return true;
  
  if (subFeature && config[subFeature]) {
    return config[subFeature].requiresAuth || false;
  }
  
  return config.requiresAuth || false;
};

/**
 * Get login prompt message for a feature/sub-feature
 */
export const getLoginPromptMessage = (featureName, subFeature = null) => {
  const config = FEATURE_CONFIG[featureName];
  if (!config) return "Please login to access this feature";
  
  if (subFeature && config[subFeature] && config[subFeature].promptMessage) {
    return config[subFeature].promptMessage;
  }
  
  return "Please login to access this feature";
};

